module.exports = {
    APP_NAME: "Media Chapter - ",
    URL: "https://www.mediachapter.us/e-panel/"
}